<link href='https://api.mapbox.com/mapbox-gl-js/v2.8.1/mapbox-gl.css' rel='stylesheet'/>
<!--<div *ngIf="loading"-->
<!--     style="height: 100%; width: 100%; position: absolute"-->
<!--     i18n>Loading map ...-->
<!--</div>-->

<div class="menu">
    <button (click)="toggleMapStyle('mapbox://styles/partnerit/cm69w5d5c002e01r5dnqsg3lz')" class="btn btn-sm btn-primary">Kort</button>
    <button (click)="toggleMapStyle('mapbox://styles/partnerit/cm69w5xcv002901qmddl88hm7')" class="btn btn-sm btn-primary">Satellit</button>
    <button (click)="toggleDriverVisibility()" class="btn btn-sm btn-primary">{{showDrivers ? 'Skjul chauffører' : 'Vis chauffører'}}</button>
    <button (click)="toggleShipmentVisibility()" class="btn btn-sm btn-primary">{{showShipments ? 'Skjul forsendelser' : 'Vis forsendelser'}}</button>
</div>
<div class="map" id="map"></div>
